<template>
  <el-main class="container">
    <Nav>
      <div slot="left">
        <el-input style="width: 250px" placeholder="请输入精选项目名称进行搜索" v-model="inputVal" clearable></el-input>
        <el-button type="primary" @click="handleSearch">搜索</el-button>
      </div>
      <div slot="right">
        <el-button v-show="hasAuthority('addProject')" type="primary" @click="handleAdd">新增精选项目</el-button>
      </div>
    </Nav>
    <div class="table-box">
      <Table
        border
        align="center"
        :column="tableInfo.column"
        :data="tableInfo.data"
        :header-row-style="{height: '100px'}"
        :header-cell-style="{background:'#f4f4f4',color:'#606266'}"
        :row-style="{height: '100px'}"
        pagination
        background
        :paginationTop="'30px'"
        :paginationAlign="'center'"
        layout="prev, pager, next, sizes, jumper"
        :page-sizes="[5, 10, 20, 30]"
        :pager-count="5"
        :current-page.sync="body.pageIndex"
        :total="tableInfo.total"
        :page-size="body.pageSize"
        @size-change="handleSizeChange"
        @p-current-change="handleCurrentChange"
      >
      </Table>
    </div>
  </el-main>
</template>

<script>
import {
  getProjectList,
  setProjectStatus,
  deleteProject
} from '@/api/featured'
import env from '@/configs/env'
export default {
  data() {
    return {
      currentPage: 1,
      pageSize: 5,
      body: {
        pageSize: 10,
        pageIndex: 1,
        word: ''
      },
      tableInfo: {
        column: [
          {
            prop: 'indexNum',
            label: '排列序号'
          },
          {
            prop: 'name',
            label: '项目名称'
          },
          {
            label: '封面图片',
            render: (h, scoped) => {
              const url = `${env.qnImgDomain}${scoped.row.picture}`
              return (
                <div>
                  <img src={url} width={150}/>
                </div>
              )
            }
          },
          {
            label: '操作',
            render: (h, scoped) => {
              let text = ''
              parseInt(scoped.row.status) === 1 ? text = '显示' : text = '隐藏'
              return (
                <div>
                  <el-link v-show={this.hasAuthority('showProject')} underline={false} type='primary' onClick={() => { this.network().setProjectStatus(scoped.row.uuid) }}>{text}</el-link>&nbsp;&nbsp;
                  <el-link v-show={this.hasAuthority('editProject')} underline={false} type='primary' onClick={() => { this.handleEdit(scoped.row) }}>编辑</el-link>&nbsp;&nbsp;
                  <el-link v-show={this.hasAuthority('deleteProject')} underline={false} type='primary' onClick={() => { this.handleDelete(scoped.row) }}>删除</el-link>&nbsp;&nbsp;
                </div>
              )
            }
          }
        ],
        data: [],
        total: 0
      },
      inputVal: ''
    }
  },
  created() {
    this.network().getProjectList()
  },
  methods: {
    network() {
      return {
        getProjectList: async() => {
          const { data } = await getProjectList(this.body)
          this.tableInfo.total = data.total
          this.tableInfo.data = data.list
        },
        setProjectStatus: async(id) => {
          await setProjectStatus(id)
          this.$message.success('修改成功')
          this.network().getProjectList()
        },
        deleteProject: async(id) => {
          await deleteProject(id)
          this.$message.success('删除成功')
          this.body.pageIndex = 1
          this.network().getProjectList()
        }
      }
    },
    handleSizeChange(val) {
      this.body.pageSize = val
      this.network().getProjectList()
    },
    handleCurrentChange(val) {
      this.body.pageIndex = val
      this.network().getProjectList()
    },
    handleEdit(row) {
      this.$router.push(`/project-list/edit/${row.uuid}`)
    },
    handleDelete(row) {
      this.$confirm('是否删除该项目？', '删除', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.network().deleteProject(row.uuid)
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    handleAdd() {
      this.$router.push('/project-list/add')
    },
    handleSearch() {
      this.body.word = this.inputVal
      this.body.pageIndex = 1
      this.network().getProjectList()
    }
  }
}
</script>

<style>

</style>
